import { tTableSortDirection } from "src/hooks/table";

// eslint-disable-next-line no-shadow
export enum tProductStatus {
  OutOfStock = "Out of Stock",
  Published = "Published",
  Unpublished = "Unpublished",
}

export type tTableProduct = {
  id: string;
  uid: string;
  name: string;
  image?: string;
  sku: string;
  status: tProductStatus;
  hasVariants: boolean;
  hasTester: boolean;
  isVariant: boolean;
  casepack: number;
  inventory: number;
  wholesalePrice: number;
  msrpPrice: number;
  testerPrice: number;
  subRows?: tTableProduct[];
};

export type tFilters = {
  status?: tProductStatus;
  term: string;
  sortedBy: keyof tTableProduct;
  sortDirection: tTableSortDirection;
};

export type tUpdatedPayload = {
  productId: string;
  isSelected?: boolean;
  variantSku?: string;
  inventory?: number;
  wholesalePrice?: string;
  msrpPrice?: string;
  testerPrice?: string;
  currentInventory?: number;
  hasVariants?: boolean;
};

export type tUpdated = {
  [rowId: string]: tUpdatedPayload;
};
